import { GambleRequestParams, SpinResponse } from '@cgs/data-access';
import { Lazy } from '@cgs/shared';
import {
  BuyFeatureParams,
  CHEAT_COMPONENT_TOKEN,
  CheatComponent,
  GAME_DATA_SERVICE_TOKEN,
  GameActionHandler,
  GameDataService,
  LAUNCH_PARAMS_STORE_TOKEN,
  LaunchParamsStore,
} from '@cgs/machines';
import { Container } from '@cgs/wge';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '../../../sdk/trifecta-sdk.adapter';
import {
  TRIFECTA_LAUNCH_PARAMS_TOKEN,
  TrifectaLaunchParamsDto,
} from '../../../models/trifecta-dto';
import { TRIFECTA_GAME_HOOK_TOKEN, TrifectaGameHook } from '../game-hook/trifecta-game-hook';

export class TrifectaGameActionHandler implements GameActionHandler {
  private readonly trifectaSDKAdapter: TrifectaSDKAdapter;
  private readonly gameDataService: GameDataService;
  private readonly gameHook: Lazy<TrifectaGameHook>;
  private readonly cheatComponent: CheatComponent;
  private readonly launchParamsStore: LaunchParamsStore;
  private readonly launchParams: TrifectaLaunchParamsDto;

  constructor(container: Container) {
    this.trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
    this.gameDataService = container.resolve<GameDataService>(GAME_DATA_SERVICE_TOKEN);
    this.gameHook = new Lazy(() => container.resolve<TrifectaGameHook>(TRIFECTA_GAME_HOOK_TOKEN));
    this.cheatComponent = container.resolve<CheatComponent>(CHEAT_COMPONENT_TOKEN);
    this.launchParamsStore = container.resolve<LaunchParamsStore>(LAUNCH_PARAMS_STORE_TOKEN);
    this.launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_LAUNCH_PARAMS_TOKEN);
  }

  public doSpin(): void {
    throw new Error('Method not implemented.');
  }

  public doStop(): void {
    throw new Error('Method not implemented.');
  }

  public buyFeature(params: BuyFeatureParams): Promise<SpinResponse | null> {
    const decimalDivider = Math.pow(10, -this.launchParams.currencyDecimals);
    this.trifectaSDKAdapter.setBet(
      params.bet * this.launchParamsStore.state.maxLines * decimalDivider
    );

    void this.trifectaSDKAdapter.buyFeature(params.featurePrice * decimalDivider, 'buyFeature', {
      cheat: this.cheatComponent.getSpinCheat()?.toJson(),
    });

    return this.gameDataService.buyFeature(params);
  }

  public gamble(params: GambleRequestParams): Promise<SpinResponse> {
    void this.trifectaSDKAdapter.gamble('', params.data.multiplier, {
      buttonIndex: params.data.buttonIndex,
      cheat: this.cheatComponent.getSpinCheat()?.toJson(),
    });
    return this.gameDataService.gamble(params);
  }
}
